"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = coupons;

var _constants = require("redux/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    coupon: null,
    preload: false
};

function coupons() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.CouponsConstants.LOAD_COUPONS:
            return (0, _extends3.default)({}, state, {
                preload: true
            });
        case _constants.CouponsConstants.LOAD_SETTINGS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                coupon: action.result
            });
        default:
            return (0, _extends3.default)({}, state, {
                preload: false
            });
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/coupons.js
// module id = 1898
// module chunks = 0